export default "__VITE_ASSET__d8316987__$_?nuxt_component=async&nuxt_component_name=SvgoGgBg15__"